import { useDispatch } from 'react-redux';
import type { ThunkDispatch } from 'redux-thunk';
import type { AnyAction } from 'redux';

export type AppDispatch = ThunkDispatch<unknown, unknown, AnyAction>;
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
